import { render, staticRenderFns } from "./EditGoalsDialog.vue?vue&type=template&id=49a56c5c&scoped=true"
import script from "./EditGoalsDialog.vue?vue&type=script&lang=js"
export * from "./EditGoalsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditGoalsDialog.vue?vue&type=style&index=0&id=49a56c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a56c5c",
  null
  
)

export default component.exports